export default __webpack_public_path__ + "bf90e150324f6237a909a487a8cd4295.png";